import { render, staticRenderFns } from "./DigitalIdCompanyModal.vue?vue&type=template&id=3b5b35f1&"
import script from "./DigitalIdCompanyModal.vue?vue&type=script&lang=js&"
export * from "./DigitalIdCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports